function normalizeEventShape(event = {}) {
  const ticketTypes = Array.isArray(event.ticketTypes) ? event.ticketTypes : Array.isArray(event.ticket_types) ? event.ticket_types : []
  return { ...event, ticketTypes, ticket_types: ticketTypes }
}

function normalizeEventDetail(detail = {}) {
  return {
    ...detail,
    event: detail?.event || null,
    ticketTypes: Array.isArray(detail?.ticketTypes) ? detail.ticketTypes : Array.isArray(detail?.ticket_types) ? detail.ticket_types : [],
  }
}

async function parseMemberEventsPayload(res) {
  const payload = await res.json()
  const data = Array.isArray(payload) ? payload : payload?.data
  return {
    payload,
    data: Array.isArray(data) ? data : [],
  }
}

export function createMemberEventsApi({ memberPortalApiGet, memberPortalApiPost, clubCode }) {
  // Refetch the canonical registration projection; never fabricate a confirmed
  // local booking from publication, payment or a successful HTTP request.
  const invalidateUpcoming = () => {
    if (typeof window !== 'undefined') window.dispatchEvent(new CustomEvent('members:upcoming-bookings-invalidated', { detail: { clubCode: String(clubCode) } }))
  }
  return {
    async listEvents() {
      const res = await memberPortalApiGet(`/api/members-portal/${clubCode}/events`)
      const { payload, data } = await parseMemberEventsPayload(res)
      if (!res.ok || payload?.ok === false) throw new Error(payload?.error || 'events_list_failed')
      return data.map(normalizeEventShape)
    },
    async getEvent(eventId) {
      const res = await memberPortalApiGet(`/api/members-portal/${clubCode}/events/${eventId}`)
      const payload = await res.json()
      if (!res.ok || payload?.ok === false) throw new Error(payload?.error || 'event_get_failed')
      return normalizeEventDetail(payload?.data || null)
    },
    async register(eventId, body) {
      const res = await memberPortalApiPost(`/api/members-portal/${clubCode}/events/${eventId}/register`, body)
      const payload = await res.json()
      if (!res.ok || payload?.ok === false) throw new Error(payload?.error || 'event_register_failed')
      invalidateUpcoming()
      return payload?.data || null
    },
    async addGuests(eventId, registrationId, body) {
      const res = await memberPortalApiPost(`/api/members-portal/${clubCode}/events/${eventId}/registrations/${registrationId}/guests`, body)
      const payload = await res.json()
      if (!res.ok || payload?.ok === false) throw new Error(payload?.error || 'event_add_guests_failed')
      invalidateUpcoming()
      return payload?.data || null
    },
    async listMyRegistrations() {
      const res = await memberPortalApiGet(`/api/members-portal/${clubCode}/my-event-registrations`)
      const { payload, data } = await parseMemberEventsPayload(res)
      if (!res.ok || payload?.ok === false) throw new Error(payload?.error || 'my_registrations_failed')
      return data
    },
  }
}
